module.exports = __webpack_public_path__ + "img/4.2e64b8ba.jpg";